<template>
  <div>
    <a @click="show">{{uid}}</a>
    <br>
    <a @click="show">{{name}}</a>
    <Modal title="学生个人信息" v-model="modal">
      <Form ref="form" class="form" :label-width="80">
        <Row>
          <i-col :span="22">
            <Form-item label="学生头像:" prop="avatarUrl">
              <a href="#" @click="openStudentPage">
                <img v-if="student.avatarUrl" :src="student.avatarUrl" alt="" width="40px">
                <img v-else src="/static/defaultAvatar.jpeg" alt="" width="40px">
              </a>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="学生姓名:" prop="nickname">
              {{student.nickname}}
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="手机号:" prop="mobile">
              {{student.mobile}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="性别:" prop="sex">
              {{student.stringSex}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="生日:" prop="birthday">
              {{student.stringBirthday}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="学校:" prop="school">
              {{student.school}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="邮箱:" prop="email">
              {{student.email}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="qq:" prop="qq">
              {{student.qq}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="所在地区:" prop="province">
              {{student.province}}{{student.city}}{{student.zone}}
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="地址:" prop="address">
              {{student.address}}
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" @click="modal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name: 'StudentInfo',
    props: {
      name: {
        type: String
      },
      uid: {
        type: Number
      }
    },
    data () {
      return {
        student: {},
        modal: false
      }
    },
    methods: {
      openStudentPage () {
        let self = this
        this.$http.get('/adminUser/getStudentCenterToken').then(res => {
          if (res.data) {
            if (self.$appConfig.active === 'prod') {
              window.open('https://hellokid.speakstreet.cn/adminUserLogin?mobile=' + self.student.mobile + '&token=' + res.data)
            } else {
              window.open('https://test-student.kouyujie.cn/adminUserLogin?mobile=' + self.student.mobile + '&token=' + res.data)
            }
          }
        })
      },
      show () {
        if (!this.uid) {
          return
        }
        this.$http.get('/userList/queryByUid', {params: {uid: this.uid}}).then(res => {
          this.student = res.data || {}
          this.modal = true
        })
      }
    },
    mounted: function () {
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// StudentInfo.vue?d5ef5c4e